
<img (click)="showDialog()" onKeyDown="showDialog()" class="pointer-cursor align-baseline me-1" height="22" width="22" src="../../../../assets/image/Filter.svg" />
<p-dialog header="Filter" [resizable]="false"  
[focusOnShow]="false" [draggable]="false" [(visible)]="display" (onHide)="closePopup()" [modal]="true" [style]="{ width: '50vw' }">
  <div id="filter-wrapper" class="container filter-wrapper pt-3 pb-5 px-5">
    <div class="row mb-4">
      <p>Select Date</p>
      <div class="col-md-6">
        <label >Date</label>
        <p-datepicker [(ngModel)]="selectedDate" icon="pi pi-chevron-down" (onSelect)="onDateSelection()" appendTo="body" [showOtherMonths]="false" [showOnFocus]="false"  [selectOtherMonths]="false" [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="true" [showIcon]="true"  inputId="min-max"></p-datepicker>
      </div>
      <div class="col-md-6 text-end">
        <label>Total Routes</label>
        <div>
          <button type="button" class="chip chip-default chip-lg "> {{blRoutesList.length}}</button>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <p>Business Location, Teams and Routes</p>
      <div class="col-lg-6 mb-2">
        <label>Business Location</label>
        <app-single-select-dropdown [className]="'blom-select'" width='100' height="48" [selectedOption]="selectedBLObject" [data]="businessLocationsList"
          (selectionChange)="onBLSelection($event)" [placeholder]="'Select Business Location'" ></app-single-select-dropdown>
      </div>
      <div class="col-lg-6">
        <label>Workshift Pattern</label>
        <app-multi-select-dropdown [className]="'blom-select'" width='100' height="48" [selectedOption]="selectedWorkshiftPatterns" [data]="workshiftPatternList"
        (selectionChange)="onWorkshiftPatternSelection($event)" [placeholder]="'Select Pattern'" ></app-multi-select-dropdown>
      </div>
      <div class="col-lg-6 mb-2">
        <label>Teams</label>
        <app-multi-select-dropdown [className]="'blom-select'" width='100' height="48" [selectedOption]="selectedBlTeams" [data]="blTeamsList"
        (selectionChange)="onTeamsSelection($event)" [placeholder]="'Select Teams'" ></app-multi-select-dropdown>
      </div>
      <div class="col-lg-6 mb-2">
        <label>Custom Route Filter</label>
        <app-single-select-dropdown [className]="'blom-select'" width="100" height="48" [selectedOption]="selectedPreferenceOption" [data]="filteredPreferenceOptions"
          (selectionChange)="onRoutePreferenceSelection($event)" [placeholder]="'Select Preference'" [showClear]="true"></app-single-select-dropdown>
      </div>
      <div class="col-lg-6">
        <label>Routes</label>
        <p-multiSelect [options]="blRoutesList" autoWidth="false" optionLabel="value" optionValue="value" [(ngModel)]="selectedBlRoutes"
          [showToggleAll]="false"
          [placeholder]="'Select Routes'" [style]="{ width: 100 + '%' ,height:'48px' }" (onChange)="onRouteSelection()" [optionDisabled]="'isDisabled'"
          selectedItemsLabel="{0} route(s) selected" [resetFilterOnHide]="true" appendTo="body">
        </p-multiSelect>
      </div>
    </div> 
    <div class="row mb-4">
      <p>Route States</p>
      <div class="col-md-12">
          <p-selectButton [options]="routeStates" [(ngModel)]="selectedRouteState" optionLabel="label" 
            (onChange)="onRouteStateChange()">
              <ng-template let-item pTemplate>
                <span class="p-togglebutton-label">
                  <span class="d-inline-block">{{item.label}}</span>
                </span>
              </ng-template>
          </p-selectButton>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        **Note: Please press <b>Apply</b> to continue
      </div>
    </div>
  </div>
 
  <ng-template #footer>
    <div>
      <button type="button" class="pn-button pn-button-primary pn-button-md me-2" onKeyDown="applyFilter();" (click)="applyFilter()" [disabled]="isFilterDisabled || !selectedRouteState">Apply</button>
      <button type="button" class="pn-button pn-button-tertiary pn-button-md " onKeyDown="onClearSelection();" (click)="onClearSelection()">Clear all</button>
    </div>
  </ng-template >
</p-dialog>